export const lightTheme = {
    background: "#ffffff",
    surface: "#ffffff",
    surfaceAlt: "#f6f8fb",
    border: "#e2e8f0",
    grid: "#e9eef4",
    gridStrong: "#cbd5e1",
    axisText: "#64748b",
    text: "#0f172a",
    mutedText: "#64748b",
    driving: "#dc2626",
    work: "#2563eb",
    rest: "#16a34a",
    availability: "#f59e0b",
    noCard: "#64748b",
    noCardStripe: "#0f172a",
    noData: "#e8edf3",
    outOfScope: "#7c3aed",
    ferry: "#0e7490",
    country: "#0e7490",
    vehicle: "#475569",
    dst: "#9333ea",
    selection: "#0f172a",
    focusRing: "#0284c7",
    tooltipBackground: "#0f172a",
    tooltipText: "#f8fafc",
    tooltipMuted: "#94a3b8",
    manualStripe: "rgba(2,6,23,0.5)",
};
export const darkTheme = {
    background: "#0b1220",
    surface: "#0f172a",
    surfaceAlt: "#111c30",
    border: "#24324a",
    grid: "#1b2940",
    gridStrong: "#334155",
    axisText: "#94a3b8",
    text: "#e2e8f0",
    mutedText: "#94a3b8",
    driving: "#f05252",
    work: "#3b82f6",
    rest: "#22c55e",
    availability: "#fbbf24",
    noCard: "#64748b",
    noCardStripe: "#f8fafc",
    noData: "#1c2940",
    outOfScope: "#a78bfa",
    ferry: "#22d3ee",
    country: "#22d3ee",
    vehicle: "#94a3b8",
    dst: "#c084fc",
    selection: "#f8fafc",
    focusRing: "#38bdf8",
    tooltipBackground: "#020617",
    tooltipText: "#f1f5f9",
    tooltipMuted: "#94a3b8",
    manualStripe: "rgba(248,250,252,0.45)",
};
export function resolveTheme(theme) {
    if (theme === "dark")
        return { ...darkTheme };
    if (theme === "light" || theme === undefined)
        return { ...lightTheme };
    return { ...lightTheme, ...theme };
}
/** Colour of an activity bucket. */
export function activityColor(theme, kind) {
    switch (kind) {
        case "driving":
            return theme.driving;
        case "work":
            return theme.work;
        case "rest":
            return theme.rest;
        case "availability":
            return theme.availability;
        default:
            return theme.noCard;
    }
}
/** Accent palette for country blocks (stable per country name). */
export const COUNTRY_PALETTE = [
    "#0e7490",
    "#7c3aed",
    "#b45309",
    "#0f766e",
    "#be123c",
    "#4d7c0f",
    "#4338ca",
    "#a16207",
];
/** Deterministic accent for a country name. */
export function countryColor(name) {
    let hash = 0;
    for (let index = 0; index < name.length; index += 1) {
        hash = (hash * 31 + name.charCodeAt(index)) >>> 0;
    }
    return COUNTRY_PALETTE[hash % COUNTRY_PALETTE.length];
}
